var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideosSlices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23807 6H11.7619C12.8095 6 13.6666 6.9 13.6666 8V18C13.6666 19.1 12.8095 20 11.7619 20H2.23807C1.19046 20 0.333313 19.1 0.333313 18V8C0.333313 6.9 1.19046 6 2.23807 6ZM1.28569 4.5H12.7143C12.7143 3.67 12.0762 3 11.2857 3H2.71427C1.92379 3 1.28569 3.67 1.28569 4.5ZM2.23807 1.5H11.7619C11.7619 0.67 11.1238 0 10.3333 0H3.66665C2.87617 0 2.23807 0.67 2.23807 1.5ZM10.1666 13.494C10.6111 13.2374 10.6111 12.5959 10.1666 12.3393L5.29165 9.52473C4.8472 9.26813 4.29165 9.58888 4.29165 10.1021L4.29165 15.7312C4.29165 16.2444 4.8472 16.5652 5.29165 16.3086L10.1666 13.494Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosSlices);
export default __webpack_public_path__ + "static/media/VideosSlices.e3b527be1904df7df48c786f58c2e023.svg";
export { ForwardRef as ReactComponent };